import { render } from "./ObFormView.vue?vue&type=template&id=1bcf5872"
import script from "./ObFormView.vue?vue&type=script&lang=js"
export * from "./ObFormView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__